export const ROLE_USER = 'ROLE_USER';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_MANAGER = 'ROLE_MANAGER';
export const ROLE_SUADMIN = 'ROLE_SUADMIN';
export const ROLE_MEMBER = 'ROLE_MEMBER';

export const ROUTE_LOGIN = 'login';
